<template>
  <div class="el-table-container templateBox">
    <el-row :gutter="15" class="allGutter">
      <el-col :span="10">
        <div class="chunkBox">
          <div class="chunkTit">快捷入口</div>
          <div class="menuItemBox">
            <el-tooltip effect="dark" :content="item.name" placement="top" v-for="(item, index) in menuList"
                        :key="index">
              <div class="menuItem" @click="selMenu(item)">
                <div class="flex_l_c">
                  <div :class="['menuIcon', item.icon, 'menuIcon'+index]"></div>
                  <div class="omit menuName">{{ item.name }}</div>
                </div>
              </div>
            </el-tooltip>
            <div class="noDataBox" v-if="!menuList.length">
              <img src="../../../assets/img/noData.png" class="noData">
              <div>暂无快捷入口</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="chunkBox">
          <div class="flex_b_c">
            <div class="chunkTit">待办事项</div>
            <div v-show="toDoTotal > 5" class="flex_r_c moreBtn" @click="toDoMore()">
              <div>更多</div>
              <div class="el-icon-arrow-right"></div>
            </div>
          </div>
          <div class="flex_l_c">
            <div :class="['tabItem', toDoStatus == '0' ? 'selTab':'']" @click="selTab('0')">我的待办</div>
            <!--                        <div :class="['tabItem', toDoStatus == '1' ? 'selTab':'' ]" @click="selTab('1')">我的已办</div>-->
          </div>
          <el-table
              :data="toDoDataList"
              v-loading="toDoLoading"
              size="small" height="calc(100% - 6rem)"
              class="table" border
              ref="multipleTable"
              :row-key="'id'"
          >
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="incidentDescription" label="事件描述"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="incidentStatus" label="事件状态" show-overflow-tooltip></el-table-column>
            <el-table-column prop="businessType" label="业务模块" show-overflow-tooltip></el-table-column>
            <el-table-column prop="localSystem" label="所在系统" show-overflow-tooltip>
              <template slot-scope="{row}">
                <div>
                  {{ $dictUtils.getDictLabel("sys_menu_local_system", row.localSystem, '') }}
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" min-width="80px" label="操作">
              <template slot-scope="{row}">
                <el-button type="text" size="small"
                           @click="deteil(row,$index)">详情
                </el-button>
                <el-button v-show="row.localSystem == '3' || row.localSystem == '3'"
                           type="text" size="small" @click="goHandleIt(row)">去处理
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="10" class="colTop">
        <div class="chunkBox">
          <div class="flex_b_c">
            <div class="chunkTit">业务板块</div>
            <el-input v-model="businessInput" class="inputSets" suffix-icon="el-icon-search" size="mini"
                      maxlength="20" @input="getBusinessSector()"
                      placeholder="请输入关键词(限20字)"></el-input>
          </div>
          <el-table
              :data="businessDataList"
              v-loading="businessLoading"
              size="small" height="calc(100% - 3rem)"
              class="table" border
              ref="multipleTable"
              :row-key="'id'"
          >
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="业务" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="14" class="colTop">
        <div class="chunkBox">
          <div class="flex_b_c">
            <div class="chunkTit">通知</div>
            <div v-show="noticeTotal > 5" class="flex_r_c moreBtn" @click="noticeMore()">
              <div>更多</div>
              <div class="el-icon-arrow-right"></div>
            </div>
          </div>
          <el-table
              :data="noticeDataList"
              v-loading="noticeLoading"
              size="small" height="calc(100% - 3rem)"
              class="table" border
              ref="multipleTable"
              :row-key="'id'"
          >
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="messageContent" label="消息内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="messageType" label="消息分类" show-overflow-tooltip>
              <template slot-scope="{row}">
                <div>{{
                    $dictUtils.getDictLabel("message_type", row.messageType, '')
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="messageTitle" label="消息类型" show-overflow-tooltip>
              <!--                            <template slot-scope="{row}">-->
              <!--                                <div>{{ $dictUtils.getDictLabel("message_type", row.messageType, '') }}</div>-->
              <!--                            </template>-->
            </el-table-column>
            <el-table-column prop="messageData" label="日期" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" min-width="50px" label="操作">
              <template slot-scope="{row,$index}">
                <el-button type="text" size="small" @click="goSee(row,$index)">去查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <see-message ref="seeMessage" @refresh="getNotice()" @switchData="switchDetail"></see-message>
    <resource-add-edit-form ref="resourceAddEditForm" @refreshData="getToDoList()"></resource-add-edit-form>
    <add-borrowing ref="addBorrowing" @refresh="getToDoList()"></add-borrowing>
    <audit-form ref="auditForm" @refreshData="getToDoList()"></audit-form>
    <batch-sorting @refreshData="getToDoList()"></batch-sorting>
    <set-toexamine ref="setToexamine" @refresh="getToDoList()"></set-toexamine>
  </div>
</template>

<script>
import SeeMessage from "@/views/modules/sys/mageCenter/seeMessage.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";
import AddBorrowing from "@/views/modules/academic/applyFor/addBorrowing.vue";
import AuditForm from '@/components/auditForm/auditForm'
import BatchSorting from "@/components/batchSorting/batchSorting.vue";
import SetToexamine from "@/views/modules/workbenches/setToexamine.vue"; // 审核弹窗

export default {
  name: "workList",
  components: {SetToexamine, BatchSorting, AddBorrowing, ResourceAddEditForm, SeeMessage, AuditForm},
  data() {
    return {
      menuList: [],

      toDoStatus: '0',
      toDoDataList: [],
      toDoTotal: 0,
      toDoLoading: false,

      businessDataList: [],
      businessLoading: false,
      businessInput: '',

      noticeDataList: [],
      detailCurr: 0,
      noticeTotal: 0,
      noticeLoading: false,
    }
  },

  mounted() {
    this.getQuickEntrance()
    this.getToDoList()
    this.getBusinessSector()
    this.getNotice()
  },

  methods: {
    //获取快捷入口
    getQuickEntrance() {
      this.$axios(this.api.user.getSysMenuShortcutKeysByCreateBy, {}, 'get').then(data => {
        if (data && data.status) {
          this.menuList = data.data
        }
      })
    },

    //获取待办事项
    getToDoList() {
      this.toDoLoading = true
      this.$axios(this.api.allCommon.commonBacklogList, {
        incidentDescription: '',
        createStartDate: '',
        createEndDate: '',
        localSystem: '',
        businessType: '',
        eventStatus: '0',
        current: 1,
        size: 5,
      }).then(data => {
        if (data && data.status) {
          this.toDoDataList = data.data.records
          this.toDoLoading = false
          this.toDoTotal = parseInt(data.data.total)
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    //业务板块
    getBusinessSector() {
      this.businessLoading = true
      this.$axios(this.api.user.sysMenuBusinessSegmentSetupList, {
        keyWord: this.businessInput
      }).then(data => {
        if (data && data.status) {
          this.businessDataList = data.data
          this.businessLoading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    //获取通知
    getNotice() {
      this.noticeLoading = true
      this.$axios(this.api.allCommon.commonMessageSelectMessageList, {
        messageClassification: '', //选择的id
        messageContent: '',
        messageType: '',
        current: 1,
        size: 5,
      }).then(data => {
        if (data && data.status) {
          this.noticeDataList = data.data.records
          this.noticeLoading = false
          this.noticeTotal = parseInt(data.data.total)
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    //快捷入口点击
    selMenu(item) {
      this.$router.push({
        path: item.href,
      })
    },

    // 待办已办
    selTab(val) {
      this.toDoStatus = val
    },

    //待办事项 更多
    toDoMore() {
      this.$router.push({
        path: '/workbenches/pending',
      })
    },

    goHandleIt(row) {
      let ids, url, type
      ids = [row.labelResourceId]
      url = this.api.academic.resourceslabelAudit
      type = '标引'
      if (row.localSystem == '3' && !row.metadataFonctionsModelDetailId) {
        url = this.api.academic.resourceapplicationAudit
        type = '借阅'
      }
      this.$refs.setToexamine.init(ids, type, url)
    },

    //待办事项 去处理
    deteil(row) {
      switch (row.localSystem) {
        case 0:
          //多源异构采集子系统
          this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId)
          break;
        case '1':
          //多源异构汇聚子系统
          this.$refs.resourceAddEditForm.init('view', row.labelResourceId, '', row.basicDataId, null, {
            labeState: 1,
            id: row.businessId
          }, 'markIndex')
          break;
        case '2':
          //资源监管子系统
          break;
        case '3':
          //学术研究子系统
          if (row.metadataFonctionsModelDetailId) {
            this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId, null, {
              labeState: 1,
              id: row.businessId
            }, 'markIndex')
          } else {
            let dataRow = JSON.parse(JSON.stringify(row))
            dataRow.id = dataRow.businessId
            this.$refs.addBorrowing.init(dataRow, 'toExamineView')
          }
          break;
        case '4':
          //多源异构发布子系统
          this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId)
          break;
        default:
          this.$refs.resourceAddEditForm.init('view', row.businessId, '', row.basicDataId)
          //公共系统
      }
    },

    //通知 更多
    noticeMore() {
      this.$router.push({
        path: '/sys/mageCenter/mageCenter',
      })
    },

    //通知 去查看
    goSee(row, index) {
      this.detailCurr = index + 1
      this.$refs.seeMessage.init(row)
    },

    //详情 0上一条 1下一条切换
    switchDetail(num) {
      if (num == 0 && this.detailCurr == 1) {
        this.$message('已是第一条')
        return
      }
      if (num == 1 && (this.detailCurr) == this.total) {
        this.$message('已是最后一条')
        return
      }
      if (num == 1 && (this.detailCurr) == 5) {
        this.$message('已是最后一条')
        return
      }
      if (num == 0) {
        this.detailCurr--
      } else {
        this.detailCurr++
      }
      this.$axios(this.api.allCommon.commonMessageSelectMessageList, {
        messageClassification: '', //选择的id
        messageContent: '',
        messageType: '',
        current: this.detailCurr,
        size: 1,
      }).then(data => {
        if (data.status) {
          this.$refs.seeMessage.init(data.data.records[0])
        } else {
          this.$message.error(data.msg);
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.templateBox {
  background: transparent;
  padding: .7rem 0 0 1rem;
}

.allGutter {
  width: 100%;
}

.chunkBox {
  height: calc((100vh - 109px - 1.7rem) / 2);
  background: #FFFFFF;
  border-radius: .7rem;
  padding: .8rem;
  box-sizing: border-box;
}

.chunkTit {
  font-size: 1.3rem;
  color: #0E1525;
  position: relative;
  margin-left: .4rem;
  padding-left: 0.93rem;
  margin-bottom: 1rem;
}

.chunkTit::before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 0.29rem;
  height: 1.3rem;
  background: #AE3F3F;
  border-radius: 0.14rem;
}

.menuItemBox {
  height: calc(100% - 4rem);
  overflow: auto;
}

.menuItem {
  display: inline-block;
  width: 32%;
  margin-right: 2%;
  border-radius: 0.29rem;
  border: 1px solid #EEEEEE;
  margin-top: 1.2rem;
  cursor: pointer;
}

.menuItem:nth-child(3n) {
  margin-right: 0;
}

.menuItem:nth-child(1), .menuItem:nth-child(2), .menuItem:nth-child(3) {
  margin-top: 0;
}

.menuIcon {
  width: 2.8rem;
  height: 2.8rem;
  background: #AE3F3F;
  border-radius: 0.57rem;
  font-size: 2rem;
  margin: 0.5rem;
  line-height: 2.8rem;
  text-align: center;
  color: #ffffff;
}

.menuName {
  font-size: 1.1rem;
  width: 60%;
}

.menuIcon1, .menuIcon7 {
  background: #007CF7;
}

.menuIcon2, .menuIcon8 {
  background: #F9AB30;
}

.menuIcon3 {
  background: #01A0EA;
}

.menuIcon4 {
  background: #7230DB;
}

.menuIcon5 {
  background: #45CD7C;
}

.noDataBox {
  padding-top: 1rem;
  text-align: center;
  font-size: 1rem;
  color: #333333;

  .noData {
    width: 7rem;
  }
}

.tabItem {
  font-size: 1.14rem;
  color: #333333;
  margin-right: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
}

.selTab {
  color: #AE3F3F;
}

.moreBtn {
  font-size: 1.1rem;
  color: #AE3F3F;
  cursor: pointer;

  .el-icon-arrow-right {
    color: #858181;
    margin-left: 0.5rem;
  }
}

.colTop {
  margin-top: .9rem;
}

.inputSets {
  width: 15rem;
  font-size: .9rem;

  ::v-deep.el-input__inner {
    height: 2.3rem;
    line-height: 2.5rem;
    border: .1rem solid #DCDFE6;
  }

  ::v-deep.el-input__suffix {
    right: .4rem;

    .el-input__suffix-inner {
      font-size: 1rem;
    }

    .el-input__icon {
      height: 2.5rem;
      line-height: 2.5rem;
    }
  }
}
</style>
